export default __webpack_public_path__ + "static/media/foliage-olive-branch-3.10b6fe38.png";